import { assert } from '../../../app/logger.js';
import { PolylineBaseMixin } from '../base/polyline_base_mixin.js';
import { LayerLeaflet } from './layer_leaflet.js';

/**
 * A wrapper around leaflet polyline.
 */
class LeafletPolyline extends PolylineBaseMixin(LayerLeaflet) {
  get path() {
    return this.native
      ? this.native.getLatLngs().map(p => ({
          lat: p.lat,
          lng: p.lng,
        }))
      : this.options.path;
  }

  set path(v) {
    assert(v instanceof Array, `[map:polyline:leaflet] no path`);
    this.options.path = v;
    if (this.native) {
      this.native.setLatLngs(v);
    }
  }

  // Protected

  createNative() {
    return new window.L.Polyline(this.options.path, this.nativeOptions);
  }

  static getDefaultNativeOptions() {
    return {
      smoothFactor: 0.5,
      color: 'red',
    };
  }

  static get nativeOptionsMapper() {
    return Object.assign({}, super.nativeOptionsMapper, {
      color: 'color',
      weight: 'weight',
    });
  }

  #native;
  #nativeMap;
}

export { LeafletPolyline };
